import { useState } from 'react';

export const useForm = (initialData = {}) => {
  const [formData, setFormData] = useState(initialData);
  
  const handleInput = (key, value) => {
    setFormData(prev => ({ ...prev, [key]: value }));
  };

  const reset = () => {
    setFormData(initialData);
  };

  return { formData, handleInput, reset, setFormData };
};
